import { StatusBar, Style } from '@capacitor/status-bar'
import { SplashScreen } from '@capacitor/splash-screen'
import { Keyboard, KeyboardResize } from '@capacitor/keyboard'
import { isNativePlatform } from '@/utils/platform'

export async function initializeNativeShell(): Promise<void> {
  if (!isNativePlatform) return

  try {
    await StatusBar.setStyle({ style: Style.Dark })
    await StatusBar.setBackgroundColor({ color: '#0f766e' })
  } catch (error) {
    console.warn('StatusBar setup skipped:', error)
  }

  try {
    await Keyboard.setResizeMode({ mode: KeyboardResize.Body })
  } catch (error) {
    console.warn('Keyboard setup skipped:', error)
  }

  try {
    await SplashScreen.hide()
  } catch (error) {
    console.warn('SplashScreen hide skipped:', error)
  }
}
